import { gql } from "@apollo/client";

export const GET_ADMIN_INDICACION_DETALLE = gql`
    query GetAdminIndicacionDetalle($idIndicacionAprobacion: Int!) {
    adminIndicacionDetalle(idIndicacionAprobacion: $idIndicacionAprobacion) {
        success,
        error,
        valorEsperado {
            idIndicacionAprobacion,
            idPaciente,
            paciente,
            edad,
            contratoActual,
            fechaContratoActual,
            cliente,
            programa,
            planCuidado,
            alergias,
            precioDiario,    
            idEstadoMedico,
            estadoMedico,
            observacionMedico,
            idEstadoComercial,
            estadoComercial,
            observacionComercial
            }
        }
    }
`;